var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('modal');
import { breakpoints, theme } from '@shapeable/theme';
import { useModal } from '../../hooks/use-modal';
import { IconButton } from './icon-button';
import { Icons } from '../icons';
export var ModalDefaultProps = {
  color: "dark",
  opacity: 0.65,
  zIndex: 500,
  showCloseButton: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    left: 0;\n    top: 0;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n  "], ["\n    left: 0;\n    top: 0;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n  "])), function (props) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", "", ";\n      z-index: ", ";\n    "], ["\n      background-color: ", "", ";\n      z-index: ", ";\n    "])), props._color, Math.round(props._opacity * 255).toString(16), props._zIndex);
  })
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    width: 24px;\n    height: 24px;\n    ", ";\n  "], ["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    width: 24px;\n    height: 24px;\n    ", ";\n  "])), theme.UNIT(2), theme.UNIT(2), theme.FILL('#FFF')),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n    width: 36px;\n    height: 36px;\n  "], ["\n    top: ", ";\n    right: ", ";\n    width: 36px;\n    height: 36px;\n  "])), theme.UNIT(3), theme.UNIT(3)),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n    width: 48px;\n    height: 48px;\n  "], ["\n    top: ", ";\n    right: ", ";\n    width: 48px;\n    height: 48px;\n  "])), theme.UNIT(4), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CloseButton: styled(IconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles)
};
export var Modal = function Modal(props) {
  var className = props.className,
      color = props.color,
      opacity = props.opacity,
      zIndex = props.zIndex,
      children = props.children,
      onClick = props.onClick,
      showCloseButton = props.showCloseButton;
  var modal = useModal();

  var closeOnClick = function closeOnClick() {
    modal.hide();
  };

  return React.createElement(My.Container, {
    onClick: onClick,
    _color: color,
    _opacity: opacity,
    _zIndex: zIndex,
    className: cls.name(className)
  }, showCloseButton && React.createElement(My.CloseButton, {
    icon: React.createElement(Icons.CrossCircle, null),
    onClick: closeOnClick
  }), children);
};
Modal.defaultProps = ModalDefaultProps;
Modal.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;